// extracted by mini-css-extract-plugin
export var audioPlayer = "_tp-0";